<template>
    <div class="recharge_left capital_first" v-if="vipRewardTradeStatus == 1" >
        <el-card class="box-card common-bg" shadow="never">
            <div slot="header" class="clearfix">
                <el-col :span="12">
                    <h3>VIP奖励 <span class="text_red_color">交易奖励</span></h3>
                </el-col>
            </div>
            <el-tabs>
                <el-tab-pane id="isFromCoupon1">
                    <h4 slot="label"> VIP奖励</h4>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <el-row>
                                <el-col :span="5" style="text-align: center;line-height: 30px;" class="common_border">
                                    <h3>可转出余额 </h3>
                                    <p class="text_red_color">{{ user_vip_reward_balance }}</p>
                                </el-col>
                                <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" class="common_border">
                                    <h3>累积奖励</h3>
                                    <p class="text_red_color">{{ user_cumulative_vip_reward }}</p>
                                </el-col>
                                <el-col :span="5" style="text-align: left;line-height: 30px;margin-left:20px;margin-top:10px;" class="common_border1">
                                    <el-button type="primary" class="button_blue_color" @click="vipRewardTransferState = true; vipRewardAmount=user_vip_reward_balance">转出</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <el-tabs stretch>
                            <div style="text-align: left;">
                                <p v-html="vipRewardDesc"></p>
                            </div>
                        </el-tabs>
    
                    </el-card>
                </el-tab-pane>
                <el-tab-pane id="isFromCoupon2">
                    <h4 slot="label"> 账单</h4>
                    <el-card>
                        <el-form :inline="true" size="mini">
                            <el-form-item label="日期">
                                <el-date-picker v-model="vipRewardDetails.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="button_blue_color" @click="getVipRewardDetails">检索</el-button>
                            </el-form-item>
                        </el-form>
                        <el-table :data="vipRewardDetails.data" size="mini" stripe style="width: 100%">
                            <el-table-column prop="sub_account_number" align="center" label="策略合约">
                            </el-table-column>
                            <el-table-column prop="stock_name" align="center" label="股票名称">
                            </el-table-column>
                            <el-table-column prop="trade_amount" align="center" label="交易价值">
                            </el-table-column>
                            <el-table-column prop="type" align="center" label="类型">
                            </el-table-column>
                            <el-table-column prop="vip_reward" align="center" label="vip奖励">
                            </el-table-column>
                            <el-table-column prop="create_time" align="center" label="时间日期">
                            </el-table-column>
                        </el-table>
                        <div class="changePage" style="padding-top: 15px;">
                            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-left" @click="prevVipReward" size="mini">上一页</el-button>
                            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-right" @click="nextVipReward" size="mini" style="float: right">
                                下一页
                            </el-button>
                        </div>
                    </el-card>
                    <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
                        只显示最近12个月记录
                    </div>
                </el-tab-pane>
            </el-tabs>
    
        </el-card>
    
        <el-dialog class="vip_reward_popup" title="VIP奖励转出" :visible.sync="vipRewardTransferState">
            <el-form ref="form" label-width="100px" size="small">
                <el-form-item>
                    <h4 slot="label">可转余额:</h4>
                    <p>{{ user_vip_reward_balance }}元</p>
                </el-form-item>
                <el-form-item>
                    <h4 slot="label">转出金额:</h4>
                    <el-input  oninput="
        if (value.startsWith('.')) value = '0' + value; 
        value = value.replace(/[^0-9.]/g, '')           
                     .replace(/(\..*?)\..*/g, '$1')     
                     .replace(/^(\d+\.?\d{0,2}).*/, '$1'); "
                    v-model="vipRewardAmount" placeholder=""></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="vipRewardTransferState = false">取消</el-button>
                <el-button type="primary"  @click="vipRewardTransfer" class="button_blue_color">确定</el-button>
            </div>
        </el-dialog>
    </div>
    </template>
    
      
    <script>
    export default {
        name: "vip_reward",
        data() {
            return {
                user_cumulative_vip_reward: 0,
                user_vip_reward_balance: 0,
                vipRewardAmount: null,
                vipRewardTransferState: false,
                vipRewardDesc: '',
                vipRewardTradeStatus: 0,
                vipRewardDetails: {
                    date: [],
                    data: [],
                    page: 1,
                    num: 20
                }
            }
        },
        computed: {},
        methods: {
            getVipRewardDetails() {
                let that = this;
    
                const requestData = {
                    nozzle: "vip_reward",
                    token: sessionStorage.getItem("token"),
                    action: "vip_reward_log",
                    page: that.vipRewardDetails.page,
                    num: that.vipRewardDetails.num,
                };
    
                if (that.vipRewardDetails.date && that.vipRewardDetails.date.length === 2) {
                    requestData.start = that.vipRewardDetails.date[0];
                    requestData.end = that.vipRewardDetails.date[1];
                }
    
                that
                    .$http({
                        url: "/",
                        method: "post",
                        data: requestData
                    })
                    .then(function (res) {
                        if (res.data.code == 1) {
                            let resData = res.data;
                            that.vipRewardDetails.data = resData.data;
                        } else if (res.data.code == 0 || res.data.code == -1) {
                            that.$message.error(res.data.msg);
                        }
                    });
            },
            getUserinfo() {
                let that = this;
                that.$http({
                        url: "/",
                        method: "post",
                        data: {
                            nozzle: "user",
                            token: sessionStorage.getItem("token")
                        }
                    })
                    .then(function (res) {
                        if (res.data.code == 1) {
                            that.user_cumulative_vip_reward = res.data.data.user_cumulative_vip_reward;
                            that.user_vip_reward_balance = res.data.data.user_vip_reward_balance;
                            that.vipRewardDesc = res.data.data.vip_reward_desc;
                            that.vipRewardTradeStatus = res.data.data.vipRewardTradeStatus;
                        } else if (res.data.code == 0 || res.data.code == -1) {
                            that.$message.error(res.data.msg);
                        }
                    });
            },
            prevVipReward() {
                let page = this.vipRewardDetails.page;
                if (page == 1) {
                    this.$message({
                        message: '已经是第一页',
                        type: 'warning'
                    });
                } else {
                    this.vipRewardDetails.page = page - 1;
                    this.getVipRewardDetails();
                }
            },
            nextVipReward() {
                let page = this.vipRewardDetails.page;
                
                if (this.vipRewardDetails.data.length < 20) {
                    this.$message({
                        message: '已经是最后一页',
                        type: 'warning'
                    });
                } else {
                    this.vipRewardDetails.page = page + 1;
                    this.getVipRewardDetails();
                }
            },
            vipRewardTransfer() {
                let that = this;
                let money = that.vipRewardAmount;
                that
                    .$http({
                        url: "/",
                        method: "post",
                        data: {
                            nozzle: "vip_reward",
                            token: sessionStorage.getItem("token"),
                            action: 'vip_reward_withdraw',
                            amount: money,
                        }
                    })
                    .then(function (res) {
                        if (res.data.code == 1) {
                            that.vipRewardTransferState = false;
                            that.$message({
                                message: res.data.msg,
                                type: 'success',
                                onClose: function () {
                                    // that.mainMethod();
                                }
                            });
                            that.mainMethod();
                        } else if (res.data.code == 0 || res.data.code == -1) {
                            that.$message.error(res.data.msg);
                        }
                    });
            },
            mainMethod() {
                this.getVipRewardDetails();
                this.getUserinfo();
            },
        },
        mounted() {
            this.getVipRewardDetails();
            this.getUserinfo();
        },
    }
    </script>
    
      
    <style scoped>
       /deep/ .el-tabs__item.is-active {
       color: #0D268D !important;
   }
   /deep/ .el-tabs__item:hover {
color: #0D268D !important;
}
/deep/ .el-tabs__active-bar{
background-color:#0D268D !important;
}
/deep/ .common_border1{
   padding:15px !important;
}

      </style><style>
    .vip_reward_popup .el-dialog {
        width: 20% !important;
    }
 
   

    </style>
    


// WEBPACK FOOTER //
// src/components/vip_reward.vue